import { render, staticRenderFns } from "./use-record.vue?vue&type=template&id=f4a763dc&"
import script from "./use-record.vue?vue&type=script&lang=js&"
export * from "./use-record.vue?vue&type=script&lang=js&"
import style0 from "./use-record.vue?vue&type=style&index=0&id=f4a763dc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports